import {ReactNode, ButtonHTMLAttributes} from "react";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";
// import {Button} from "@/shared/ui/Button";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
    children: ReactNode;
};

export const BasketButton = ({children, ...props}: Props) => {
    const {basketStore} = useStoreMobx();

    // return (
    //     <Button variant={`icon`} onClick={() => basketStore.getBasket()} {...props}>
    //         {children}
    //     </Button>
    // );

    return (
        <button type={`button`} onClick={() => basketStore.getBasket()} {...props}>{children}</button>
    );
};
